$(document).ready(function() {
  
  $(document).on('change', ".selected_part", function (e) {
    console.log("*****9999****");
    var part_id = e.target.value;
    var $this = $(this);
    $.ajax({
      type: 'GET',
      url: `/parts/${part_id}`,
      dataType: 'json',
      success: function(response) {

        console.log();
        console.log($this.html());
        $this.siblings('.useable_unit').html(`${response.useable_unit}`)
        $this.siblings('.useable_unit').addClass('useable_unit_css')
        console.log('Response is =>'  + response.useable_unit);
      },
      error: function(error){console.log(error)}
      });

    })


  $(document).on('change', "#primary_asset_asset_type_id", function (e)
  {
    var assetTypeID = $(this).val()
    console.log(assetTypeID)
    $.ajax({
    type: 'GET',
    dataType: 'json',
    url: `/api/v1/checklists`,
    data: { asset_type_id: assetTypeID },
    success: function(response) {

      console.log("response");
      console.log(response);
      var checklistIds = response.data.map(item => { return item.id;});
      // const checklistIds = response.data.flatMap(item =>
      //   item.checklist_revisions
      //     ?.filter(rev => rev.status === 'active')
      //     .map(rev => rev.id) || []
      // );

      console.log(checklistIds)
      $(`#primary_asset_checklist_ids`).val(checklistIds).trigger('change');
    },
    error: function(error){console.log(error)}
    });
  })
});
